// errors could happen by user input
export const unkownArticle = 'unkownArticle';
export const unkownExhibition = 'unkownExhibition';
export const unknownTour = 'unknownTour';
export const unknownTourArticle = 'unknownTourArticle';
export const pleaseEnterACode = 'pleaseEnterACode';
export const unkownCode = 'unkownCode';
export const arNotSuported = 'arNotSuported';
export const languageNotSupported = 'languageNotSupported';
export const geoPositionPermissionDenied = 'geoPositionPermissionDenied';
export const geoPositionPositionUnavailable = 'geoPositionPositionUnavailable';
export const setFontSize = 'setFontSize';
export const setColorMode = 'setColorMode';
export const landingArticleIdNotSet = 'landingArticleIdNotSet';
export const failedLoadingStyles = 'failedLoadingStyles';
export const augmentedRealityIndexDownloadFailed = 'augmentedRealityIndexDownloadFailed';
export const nativeApiVersionTooOld = 'nativeApiVersionTooOld';

// Tour Errros
export const tourNotActive = 'tourNotActive';
export const tourInvalidPosition = 'tourInvalidPosition';
export const articleNotInTour = 'articleNotInTour';

// System Errors should not happen by user imput
export const unkownCommand = 'unkownCommand';
export const videoNotSupported = 'videoNotSupported';

export const viewStateUnkownUiComponent = 'viewStateUnkownUiComponent';
export const unkownMediaObject = 'unkownMediaObject';
export const onNativeLoadError = 'onNativeLoadError';
export const unkownLinkPattern = 'unkownLinkPattern';

export const dataSourceConfigDownloadFailed = 'dataSourceConfigDownloadFailed';
export const mapDownloadFailed = 'mapDownloadFailed';
export const mapNotConfigured = 'mapNotConfigured';
export const articleDownloadFailed = 'articleDownloadFailed';
export const noCaptivePortalExhibitSet = 'noCaptivePortalExhibitSet';
export const dateLocalizationNotAvailable = 'dateLocalizationNotAvailable';
export const cssVersionMissmatch = 'cssVersionMissmatch';
export const cssVersionMissing = 'cssVersionMissing';

// pacakgeSyncer
export const packageSyncerNotAvaible = 'packageSyncerNotAvaible';
export const packageSyncerUnkownSubPart = 'packageSyncerUnkownSubPart';
export const packageSyncerTourNotDownloaded = 'packageSyncerTourNotDownloaded';
export const packageSyncerDownloadError = 'packageSyncerDownloadError';
export const packageSyncerDeleteError = 'packageSyncerDeleteError';
export const packageSyncerExhibitionNotDownloaded = 'packageSyncerExhibitionNotDownloaded';

// AR Engine
export const arDescriptionNotLoaded = 'arDescriptionNotLoaded';
export const augmentedRealityReturnError = 'augmentedRealityReturnError';
export const augmentedRealityEngineVersionMissmatch = 'augmentedRealityReturnError';

// 360 viewer
export const vr360OpenFailed = 'vr360OpenFailed';

// Forms, surveys
export const formIncomplete = 'formIncomplete';
export const formSendError = 'formSendError';

// MQTT
export const mqttNotAvailable = 'mqttNotAvailable';

// Progressive Web App
export const pwaInitalSync = 'pwaInitalSync';
